import { defineStore } from 'pinia';

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: localStorage.getItem('locale') || 'ar',
  }),

  actions: {
    setLocale(locale) {
      this.locale = locale;
      localStorage.setItem('locale', locale);

      // Update document direction
      document.documentElement.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', locale);

      // Update font based on locale
      if (locale === 'ar') {
        document.body.style.fontFamily = "'Cairo', sans-serif";
      } else {
        document.body.style.fontFamily = "'Plus Jakarta Sans', sans-serif";
      }
    },

    initLocale() {
      this.setLocale(this.locale);
    },
  },
});
